import {Enum} from 'enumify';

export default class GenderType extends Enum {}

GenderType.initEnum({
  MALE: {
    title: 'Male',
  },
  FEMALE: {
    title: 'Female',
  },
  OTHER: {
    title: 'Other',
  },
});



// WEBPACK FOOTER //
// ./src/constants/GenderType.js